module.exports = __webpack_public_path__ + "static/posturescan-logo-18f4780248905cb83cc89087f62a8519.png";